import React from "react";
import MuiIconDocumentList from "@mui/icons-material/Description";
import MuiIconCreateDocument from "@mui/icons-material/NoteAdd";

// Source
import * as HelperSrc from "../../HelperSrc";
import ControllerSidebar from "../../controller/Sidebar";
import ControllerLocalization from "../../controller/Localization";

let isRendered = false;

export const viewMenuData: React.FC = () => {
    // Variable
    const controllerSidebar = new ControllerSidebar(isRendered);
    const controllerLocalization = new ControllerLocalization(isRendered);

    // Method
    controllerSidebar.initializeHook();
    controllerLocalization.initializeHook();

    // Render
    isRendered = true;

    if (controllerLocalization.getStorageMain) {
        return (
            <div>
                <p className="text">
                    <span className="label">- {controllerLocalization.getStorageMain.document}</span>
                </p>
                <div
                    className="icon_text"
                    data-at_id="sidebar_create_document"
                    onClick={() => {
                        if (controllerSidebar.getStorageRoute) {
                            HelperSrc.routerHistoryPush(controllerSidebar.getStorageRoute.documentCreate.path);
                        }
                    }}
                >
                    <MuiIconCreateDocument />
                    <p>{controllerLocalization.getStorageMain.create}</p>
                    <div className="description">{`${controllerLocalization.getStorageMain.document} - ${controllerLocalization.getStorageMain.create}`}</div>
                </div>
                <div
                    className="icon_text"
                    data-at_id="sidebar_document_list"
                    onClick={() => {
                        if (controllerSidebar.getStorageRoute) {
                            HelperSrc.routerHistoryPush(controllerSidebar.getStorageRoute.documentList.path);
                        }
                    }}
                >
                    <MuiIconDocumentList />
                    <p>{controllerLocalization.getStorageMain.list}</p>
                    <div className="description">{`${controllerLocalization.getStorageMain.document} - ${controllerLocalization.getStorageMain.list}`}</div>
                </div>
            </div>
        );
    } else {
        return <></>;
    }
};

export const viewMasterData: React.FC = () => {
    // Variable
    const controllerSidebar = new ControllerSidebar(isRendered);
    const controllerLocalization = new ControllerLocalization(isRendered);

    // Method
    controllerSidebar.initializeHook();
    controllerLocalization.initializeHook();

    // Render
    isRendered = true;

    if (controllerLocalization.getStorageMain) {
        return <></>;
    } else {
        return <></>;
    }
};
